
import {Component, Vue} from "vue-property-decorator";
import HarcMasrafOdeFormWizard from "@/components/forms/form-wizard/eicrapro/HarcMasrafOdeFormWizard.vue";
import {TaskTuru} from "@/plugins/uyap-plugin/enum/TaskTuru";
import UyapBagliDegilView from "@/views/eicrapro/UyapBagliDegilView.vue";

@Component({
  components: {UyapBagliDegilView, HarcMasrafOdeFormWizard}
})
export default class HarcMasrafOdeView extends Vue {
  taskTuru = TaskTuru;
}
